/* global $ */
import $ from "jquery";
import { tableResponsive} from '../table';
import { setImages } from '../images';
import { checkNested, getConfig, setVariable, adjustVariables, urlParseCheck, checkDocument } from "../general_functions";
import { compileResources } from "../compile"; 
import { messagefromSystem } from "./dialog_messages";
import { set_accordian } from "../accordian";

export const getAimData = (id) => {

    let config = getConfig();
    let servioid = config.servioId;

    $.when(
        $.getJSON(window.apiUrl + "/api/PublicContentApi/find/" + id),
        // $.getJSON("https://prokom-servio-botbackend.azurewebsites.net/" + servioid + "/api/setting"),
        // $.getJSON("https://prokom-servio-botbackend.azurewebsites.net/" + servioid + "/api/link"),
        //$.getJSON(window.apiUrl + "/api/PublicContentApi/getall/"+clientid)
        $.ajax({
            type: "POST",
            url: "https://kariadmin.azurewebsites.net/api/clientvariables",
            contentType: "application/json-patch+json",
            data: JSON.stringify({
                "clientId": client.servioId
            }),
        })
    ).fail(function() {

        return 404;

    }).done(function(article, variables) {

        // const allVariable = [...karivars[0], ...karilinks[0]];


        variables = adjustVariables(variables[0]);


        const allVariable = variables;


        if (checkNested(article[0], "pageTypeId")) {
            if (article[0].pageTypeId === "mal_artikkel") {
                parent.location = "/artikkel/" + id;
                return;
            }
        }
        else {
            parent.location = "/404";
        }

        const removeExtraSpace = function(content) {
            const regex = /<p>&nbsp;<\/p>||<p>/gi;
            content = content.replace(regex, "");
            return content;
        }

        let content = decodeURIComponent(article[0].contentObject);


        let me = $("<div>" + content + "</div>");
        me.find(".var_text").contents().unwrap();
        content = me.html();

        let allRelateds = [];

        const pushRelatedContentObjects = (obj) => {
            if (obj.relatedContentObjects) {
                obj.relatedContentObjects.forEach((relObj) => {
                    allRelateds.push(relObj);
                    if (relObj.relatedContentObjects) {
                        pushRelatedContentObjects(relObj);
                    }
                });
            }
        };

        pushRelatedContentObjects(article[0]);

        content = compileResources(content, article[0].relatedContentObjects);

        content = removeExtraSpace(content);

        content = tableResponsive(content).html();

        content = setImages(content);

        content = setVariable(content, allVariable);


        // console.log("setting accordian, text-reply");
        content = set_accordian(content);



        content = urlParseCheck(content);


        content = checkDocument(content, allRelateds);


        if (article[0].pageTypeId === "mal_blokk") {
            messagefromSystem(content);
        }
        else {
            window.location.href = "/artikkel/" + id;
        }


        $(".removewhendone").remove();


        // createGallery();


    });
}
